// 疫情防控
import EpidemicOverView from '../view/EpidemicSituation/EpidemicOverView/EpidemicOverView'
import EpidemicSituationRegister from '../view/EpidemicSituation/EpidemicSituationRegister/EpidemicSituationRegister'
import Temperature from '../view/EpidemicSituation/Temperature/Temperature'
import epidemicSituationNav from '../view/EpidemicSituation/epidemicSituationNav'

export default [
    /* 疫情防控 */
    {
        path: '/epidemic_over_view',
        name: 'epidemic-over-view',
        components: {
            default: epidemicSituationNav,
            a: EpidemicOverView
        }
    },
    {
        path: '/epidemic_situation_register',
        name: 'epidemic-situation-register',
        components: {
            default: epidemicSituationNav,
            a: EpidemicSituationRegister
        }
    },
    {
        path: '/epidemic_situation_register/:id',
        name: 'epidemic-situation-register2',
        components: {
            default: epidemicSituationNav,
            a: EpidemicSituationRegister
        }
    },
    {
        path: '/temperature',
        name: 'temperature',
        components: {
            default: epidemicSituationNav,
            a: Temperature
        }
    },
    {
        path: '/temperature/:id',
        name: 'temperature2',
        components: {
            default: epidemicSituationNav,
            a: Temperature
        }
    },
    /* 疫情防控 */


]


// WEBPACK FOOTER //
// ./src/router/EpidemicSituation.js